'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var GridColumnConditionallyEditableService = function GridColumnConditionallyEditableService(featureToggleService, directForecastingConfigurationService) {
  var conditions = {
    /**
     * Return true if given row is newly added
     *
     * @param loadedData
     * @param rowIndex
     * @returns {boolean}
     */
    isNewRow: function isNewRow(loadedData, rowIndex) {
      return loadedData[rowIndex].isNewlyAdded === true;
    },
    /**
     * Return true if given row is newly added or is duplicated
     *
     * @param loadedData
     * @param rowIndex
     * @returns {boolean}
     */
    isNewRowOrDuplicate: function isNewRowOrDuplicate(loadedData, rowIndex) {
      var row = loadedData[rowIndex];
      return row.isNewlyAdded === true || row.isRowEditable === true;
    },
    /**
     * Return true if given column's value is 'true'
     *
     * @param loadedData
     * @param rowIndex
     * @param datafield
     * @param value
     * @param columnName
     * @returns {boolean}
     */
    isColumnTrue: function isColumnTrue(loadedData, rowIndex, datafield, value, columnName) {
      return loadedData[rowIndex][columnName] === true;
    },
    checkParentPermission: function checkParentPermission(loadedData, rowIndex) {
      var row = loadedData[rowIndex];
      var parent = null;
      var editable = [];
      _.forEach(loadedData, function (item) {
        //parentIndex = row.parents.indexOf(item.component);
        parent = _.find(row.parents, ['component', item.component]);
        if (parent) {
          if (parent.privilege === 'WRITE') {
            editable.push(item.isEditable);
          } else if (parent.privilege === 'READ') {
            editable.push(item.isViewable);
          }
        } else if (row.component === 'data-extract' || row.component === 'history') {
          editable = false;
        }
      });
      if (editable.length === 0) {
        return true;
      }

      //This assumes an OR condition for parent permissions
      return _.reduce(editable, function (prev, curr) {
        return prev || curr;
      });
    },
    isRegularAdjustmentEditable: function isRegularAdjustmentEditable(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      if (dependencyField && isDependencyFieldEmpty(loadedData[rowIndex], dependencyField)) {
        return false;
      }
      return featureToggleService.isEnabled('MAPPED_MODE');
    },
    isMappedAdjustmentEditable: function isMappedAdjustmentEditable(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      if (dependencyField && isDependencyFieldEmpty(loadedData[rowIndex], dependencyField)) {
        return false;
      }
      return featureToggleService.isEnabled('SPOS') && checkIfRowHasDefaultPOS(loadedData[rowIndex]) || featureToggleService.isDisabled('SPOS');
    },
    isNotUserManagementComponent: function isNotUserManagementComponent(loadedData, rowIndex) {
      var rowData = loadedData[rowIndex];
      if (rowData.viewEnabled) {
        return rowData.component !== 'user-management';
      } else {
        return false;
      }
    },
    isNotMatchStrategy: function isNotMatchStrategy(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isNotMatchStrategy = loadedData[rowIndex][dependencyField] !== 'MATCH';
      if (!isNotMatchStrategy) {
        if (fieldName === 'amount') {
          loadedData[rowIndex][fieldName] = 0;
        } else if (fieldName === 'percentageIndicator') {
          loadedData[rowIndex][fieldName] = 'A';
        }
      }
      return isNotMatchStrategy;
    },
    isDisabledWhenOrdinalMatching: function isDisabledWhenOrdinalMatching(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isDisabledWhenOrdinalMatching = loadedData[rowIndex][dependencyField] !== 'ORDINAL';
      if (!isDisabledWhenOrdinalMatching) {
        if (fieldName === 'competitorEntryLevelRbds') {
          loadedData[rowIndex][fieldName] = null;
        }
      }
      return isDisabledWhenOrdinalMatching;
    },
    isDisabledGenerateNewCancelWhenTactical: function isDisabledGenerateNewCancelWhenTactical(loadedData, rowIndex, fieldName) {
      var isDisabledWhenTactical = loadedData[rowIndex]['marketListCategory'] === 'TACTICAL';
      if (isDisabledWhenTactical) {
        if (fieldName === 'generateNewCancel') {
          loadedData[rowIndex][fieldName] = true;
        }
      }
      return !isDisabledWhenTactical;
    },
    isEnableBasedOnRbdMethod: function isEnableBasedOnRbdMethod(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      if (checkFieldToDisableForRbdToRbdMethod(loadedData, rowIndex, fieldName, dependencyField) || checkFieldToDisableForOrdinalRbdMethod(loadedData, rowIndex, fieldName, dependencyField) || checkFieldToDisableForFbcMappingRbdMethod(loadedData, rowIndex, fieldName, dependencyField) || checkFieldToDisableForUpperBoundRbdMethod(loadedData, rowIndex, fieldName, dependencyField) || checkFieldToDisableForValueBasedRbdMethod(loadedData, rowIndex, fieldName, dependencyField)) {
        loadedData[rowIndex][fieldName] = null;
        return false;
      }
      return true;
    },
    isDisabledWhenNotRbdToRbdMatching: function isDisabledWhenNotRbdToRbdMatching(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isDisabledWhenNotRbdToRbdMatching = loadedData[rowIndex][dependencyField] === 'RBD TO RBD' && loadedData[rowIndex]['category'] === 'STRUCTURAL';
      if (!isDisabledWhenNotRbdToRbdMatching) {
        if (fieldName === 'useForLadderGeneration') {
          loadedData[rowIndex][fieldName] = true;
        }
      }
      return isDisabledWhenNotRbdToRbdMatching;
    },
    isDisableUseForLadderGeneration: function isDisableUseForLadderGeneration(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isDisableUseForLadderGeneration = loadedData[rowIndex][dependencyField] === 'ENTRY LEVEL RBD' || loadedData[rowIndex][dependencyField] === 'ORDINAL' || loadedData[rowIndex]['ladderMethod'] === 'NONE';
      if (isDisableUseForLadderGeneration) {
        if (fieldName === 'useForLadderGeneration') {
          if (loadedData[rowIndex]['ladderMethod'] === 'NONE') {
            loadedData[rowIndex][fieldName] = false;
          } else {
            loadedData[rowIndex][fieldName] = true;
          }
        }
      }
      return !isDisableUseForLadderGeneration;
    },
    isDisabledWhenCategoryStructural: function isDisabledWhenCategoryStructural(loadedData, rowIndex, fieldName) {
      var isDisabledWhenCategoryStructural = loadedData[rowIndex]['category'] === 'STRUCTURAL';
      if (isDisabledWhenCategoryStructural) {
        if (fieldName === 'splitOnStruc') {
          loadedData[rowIndex][fieldName] = false;
        }
      }
      return !isDisabledWhenCategoryStructural;
    },
    isNotLoadFactorTargetType: function isNotLoadFactorTargetType(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      return loadedData[rowIndex][dependencyField] !== 'LoadFactor';
    },
    isNotThroughSegment: function isNotThroughSegment(loadedData, rowIndex) {
      return !isDependencyFieldEmpty(loadedData[rowIndex], 'legClassId');
    },
    isNotSpecialEvent: function isNotSpecialEvent(loadedData, rowIndex) {
      return !loadedData[rowIndex].isSpecialEvent;
    },
    isNotDiscontinued: function isNotDiscontinued(loadedData, rowIndex) {
      var isDiscontinuedRoutesEnabled = featureToggleService.isEnabled('DISCONTINUED_ROUTES');
      var isServiceDiscontinued = loadedData[rowIndex].isDiscontinued === 'Yes';
      return !(isDiscontinuedRoutesEnabled && isServiceDiscontinued);
    },
    isNotDirectForecasting: function isNotDirectForecasting(loadedData, rowIndex) {
      if (featureToggleService.isDisabled('DIRECT_FORECAST_ENABLE')) {
        return true;
      }
      return !directForecastingConfigurationService.isDirectForecastEnabled(loadedData[rowIndex]);
    },
    isNotSignificantMarket: function isNotSignificantMarket(loadedData, rowIndex) {
      return !loadedData[rowIndex]['isSignificantOriginal'];
    },
    isNotInOlapRequestQueue: function isNotInOlapRequestQueue(loadedData, rowIndex) {
      return !loadedData[rowIndex].isMarketInPendingOlapQueue;
    }
  };
  function checkFieldToDisableForRbdToRbdMethod(loadedData, rowIndex, fieldName, dependencyField) {
    return ['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL'].includes(loadedData[rowIndex][dependencyField]) && ['fbcMappingCompetitorAirline', 'fbcMappingCompetitorFbc', 'upperBoundFbc', 'upperBoundAmt', 'typeIndicator', 'minFare', 'maxFare', 'currencyType'].includes(fieldName);
  }
  function checkFieldToDisableForOrdinalRbdMethod(loadedData, rowIndex, fieldName, dependencyField) {
    return loadedData[rowIndex][dependencyField] === 'ORDINAL' && fieldName === 'competitorEntryLevelRbd';
  }
  function checkFieldToDisableForFbcMappingRbdMethod(loadedData, rowIndex, fieldName, dependencyField) {
    return loadedData[rowIndex][dependencyField] === 'FBC MAPPING' && ['competitorAirline', 'competitorEntryLevelRbd', 'upperBoundFbc', 'upperBoundAmt', 'typeIndicator', 'minFare', 'maxFare', 'currencyType'].includes(fieldName);
  }
  function checkFieldToDisableForUpperBoundRbdMethod(loadedData, rowIndex, fieldName, dependencyField) {
    return loadedData[rowIndex][dependencyField] === 'UPPER BOUND' && ['competitorAirline', 'competitorEntryLevelRbd', 'fbcMappingCompetitorAirline', 'fbcMappingCompetitorFbc', 'minFare', 'maxFare', 'currencyType'].includes(fieldName);
  }
  function checkFieldToDisableForValueBasedRbdMethod(loadedData, rowIndex, fieldName, dependencyField) {
    return loadedData[rowIndex][dependencyField] === 'VALUE BASED' && ['competitorAirline', 'competitorEntryLevelRbd', 'fbcMappingCompetitorAirline', 'fbcMappingCompetitorFbc', 'upperBoundFbc', 'upperBoundAmt', 'typeIndicator'].includes(fieldName);
  }
  function checkIfRowHasDefaultPOS(rowData) {
    return !_.isNil(rowData.posName) && rowData.posName === 'Default' || !_.isNil(rowData.significantPOS) && rowData.significantPOS === 'Default';
  }
  function isDependencyFieldEmpty(rowData, fieldName) {
    return _.isNil(rowData[fieldName]);
  }
  function isColumnConditionallyEditable(editable) {
    return (0, _typeof2["default"])(editable) === 'object' && (_.includes(_.keys(conditions), editable.condition) || _.includes(editable.condition, ','));
  }
  function areEditableConditionsMet(editableCondition, params) {
    if (!_.includes(editableCondition, ',')) {
      return conditions[editableCondition].apply(null, params);
    }
    var conditionsToCheck = _.split(editableCondition, ',');
    return _.reduce(conditionsToCheck, function (result, condition) {
      if (result) {
        return conditions[condition].apply(null, params);
      } else {
        return false;
      }
    }, true);
  }
  return {
    isColumnConditionallyEditable: isColumnConditionallyEditable,
    areEditableConditionsMet: areEditableConditionsMet,
    isNewRow: conditions.isNewRow,
    isNewRowOrDuplicate: conditions.isNewRowOrDuplicate,
    isColumnTrue: conditions.isColumnTrue,
    checkParentPermission: conditions.checkParentPermission,
    isNotUserManagementComponent: conditions.isNotUserManagementComponent,
    isMappedAdjustmentEditable: conditions.isMappedAdjustmentEditable,
    isRegularAdjustmentEditable: conditions.isRegularAdjustmentEditable,
    isNotLoadFactorTargetType: conditions.isNotLoadFactorTargetType,
    isNotThroughSegment: conditions.isNotThroughSegment,
    isNotMatchStrategy: conditions.isNotMatchStrategy,
    isNotSpecialEvent: conditions.isNotSpecialEvent,
    isDisabledWhenOrdinalMatching: conditions.isDisabledWhenOrdinalMatching,
    isDisabledWhenNotRbdToRbdMatching: conditions.isDisabledWhenNotRbdToRbdMatching,
    isDisableUseForLadderGeneration: conditions.isDisableUseForLadderGeneration,
    isDisabledWhenCategoryStructural: conditions.isDisabledWhenCategoryStructural,
    isEnableBasedOnRbdMethod: conditions.isEnableBasedOnRbdMethod,
    isNotDiscontinued: conditions.isNotDiscontinued,
    isNotDirectForecasting: conditions.isNotDirectForecasting,
    isNotSignificantMarket: conditions.isNotSignificantMarket,
    isNotInOlapRequestQueue: conditions.isNotInOlapRequestQueue,
    isDisabledGenerateNewCancelWhenTactical: conditions.isDisabledGenerateNewCancelWhenTactical
  };
};
GridColumnConditionallyEditableService.$inject = ['FeatureToggleService', 'DirectForecastingConfigurationService'];
module.exports = GridColumnConditionallyEditableService;